import { gql } from '@apollo/client'

export const BOOK_APPOINTMENT = gql`
  mutation BookAppointment(
    $appointmentId: ID!
    $patient: PatientInput!
    $locationId: ID
    $providerId: ID
    $partnerId: ID
  ) {
    bookAppointment(
      appointmentId: $appointmentId
      patient: $patient
      locationId: $locationId
      providerId: $providerId
      partnerId: $partnerId
    ) {
      __typename
      id
      start
      end
      bookedAt
    }
  }
`
